module.exports = __webpack_public_path__ + "static/media/arrow-left.b72a9aa5.svg";